import React from "react";
import { Box, Text, Button, VStack, Heading } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { usePermissions } from "hooks/usePermissions";

interface UnauthorizedPageProps {
  message?: string;
  showBackButton?: boolean;
}

export function UnauthorizedPage({ 
  message = "Vous n'avez pas les permissions nécessaires pour accéder à cette page.",
  showBackButton = true 
}: UnauthorizedPageProps) {
  const navigate = useNavigate();
  const { has } = usePermissions();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    if (has("get taxdashboard")) {
      navigate("/tax/dashboard");
    } else if (has("get dashboard")) {
      navigate("/dashboard");
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      padding={6}
      textAlign="center"
    >
      <VStack spacing={6}>
        <Heading as="h1" fontSize="6rem" color="red.500">
          403
        </Heading>
        
        <Heading as="h2" size="lg" color="gray.700">
          Accès Refusé
        </Heading>
        
        <Text fontSize="lg" maxWidth="600px" color="gray.600">
          {message}
        </Text>
        
        {showBackButton && (
          <Box display="flex" gap={4}>
            <Button 
              variant="outline" 
              onClick={handleGoBack}
              minWidth="120px"
            >
              Retour
            </Button>
            <Button 
              colorScheme="blue"
              onClick={handleGoHome}
              minWidth="120px"
            >
              Accueil
            </Button>
          </Box>
        )}
      </VStack>
    </Box>
  );
}
